module.exports = __webpack_public_path__ + "img/footer.442bfebf.svg";